import React from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'

const PageTitle = (props) => {
    const { i18n } = useTranslation();
    return (
        <section className="wpo-page-title">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="wpo-breadcumb-wrap">
                            <h2>{props.pageTitle}</h2>
                            <ol className="wpo-breadcumb-wrap">
                                <li><Link to="/">{i18n.language === 'en' ? 'Home' : 'الصفحة الرئيسية'}</Link></li>
                                <li><span>{props.pagesub}</span></li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default PageTitle;